module.exports = __webpack_public_path__ + "img/3.e152c234.jpg";